import { isAvatarPresetId } from "../../avatars/index.js";

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const generateRandomColor = () => {
    const r = Math.random();
    const g = Math.random();
    const b = Math.random();
    return `rgb(${r * 255}, ${g * 255}, ${b * 255}, 0.8)`;
};

export const getRoomIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const roomFromQuery = urlParams.get("room");

    return roomFromQuery ?? "defaultRoom";
};

export const getNameFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const usernameFromQuery = urlParams.get("user");

    return usernameFromQuery ?? null;
};

export const getColorFromUrl = () => {
    const colorFromQuery = new URLSearchParams(window.location.search).get(
        "color",
    );

    return /^#[0-9a-f]{6}$/i.test(colorFromQuery || "") ? colorFromQuery : null;
};

export const getAvatarFromUrl = () => {
    const avatarFromQuery = new URLSearchParams(window.location.search).get(
        "avatar",
    );

    return isAvatarPresetId(avatarFromQuery) ? avatarFromQuery : null;
};

export const generateUID = () => {
    if (crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    console.log("Crypto not available");
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        },
    );
};
